@if ((useLazyLoad && !isLoaded) || pushs?.length > 0) {
  <wc-wrapper [contentWrapper]="wrapper">
    <sd-push-slider sd-component-wrapper-component
      (clicked)="onClickLink($event)"
      [pushSliderConfig]="pushSliderConfig"
      [titleLevel]="titleLevelHeading"
      [size]="sizesEnum.s"
      [pushs]="pushs"
      [context]="context"
      [twicPicsAutoSize]="!isFirst"
      [brand]="brandCorner"
      [isLoading]="useLazyLoad && !isLoaded"
    />
  </wc-wrapper>
}
